import React from "react";
import "./Header.css";
import logo from "../Assets/logo.png";
import { FaInstagram, FaWhatsapp, FaFacebookF } from "react-icons/fa";

function Header() {
  return (
    <header className="header">
      <div className="header-left">
      <a href="/">
  <img src={logo} alt="AMY Floris Logo" className="header-logo" />
     </a>

     <a href="/" style={{ textDecoration: "none" }}>
  <h1 className="header-title">We Nourish you to flourish</h1>
  </a>
      </div>

      <div className="header-right">
        <a
          href="https://www.instagram.com/amy_floris_/"
          target="_blank"
          rel="noreferrer"
          className="social-icon instagram"
        >
          <FaInstagram />
        </a>
        <a
          href="https://wa.me/919443407953"
          target="_blank"
          rel="noreferrer"
          className="social-icon whatsapp"
        >
          <FaWhatsapp />
        </a>
        <a
          href="https://www.facebook.com/people/Amy-Floris/61559172038501/"
          target="_blank"
          rel="noreferrer"
          className="social-icon facebook"
        >
          <FaFacebookF />
        </a>
      </div>
    </header>
  );
}

export default Header;
